import {
  Integration as IntegrationType,
  KameletBinding as KameletBindingType,
  Pipe as PipeType,
} from '@kaoto/camel-catalog/types';
import { isDefined } from '@kaoto/forms';

import { KaotoResource } from '../kaoto-resource';
import { IntegrationResource } from './integration-resource';
import { KameletResource } from './kamelet-resource';
import { IKameletDefinition } from './kamelets-catalog';
import { PipeResource } from './pipe-resource';
import { SourceSchemaType } from './source-schema-type';

export class CamelKResourceFactory {
  static getCamelKResource(
    json?: IntegrationType | IKameletDefinition | KameletBindingType | PipeType,
    type?: SourceSchemaType,
  ): KaotoResource | undefined {
    const jsonRecord =
      isDefined(json) && !Array.isArray(json) && typeof json === 'object' ? (json as Record<string, unknown>) : {};
    const kind = jsonRecord['kind'] ?? type;

    if (!isDefined(kind)) {
      return undefined;
    }

    switch (kind) {
      case SourceSchemaType.Integration:
        return new IntegrationResource(jsonRecord as IntegrationType);
      case SourceSchemaType.Kamelet:
        return new KameletResource(jsonRecord as IKameletDefinition);
      case SourceSchemaType.KameletBinding:
        return new PipeResource({
          ...jsonRecord,
          kind: SourceSchemaType.KameletBinding,
        } as KameletBindingType);
      case SourceSchemaType.Pipe:
        return new PipeResource(jsonRecord as PipeType);
      default:
        return undefined;
    }
  }
}
